"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var orders_1 = require("./orders");
exports.OrderService = orders_1.OrderService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/order-list/services/index.js
// module id = 416
// module chunks = 0